export default function (str: string | undefined | null): string {
  if (!str) {
    return ''
  }
  return str.replace(/^\S+/, (word) => word.toLowerCase())
}
